import { LoadingOutlined } from "@ant-design/icons";
import { Typography } from "antd";

interface SpinWithDescriptionProps {
  tip?: string
  debug?: string
}
const SpinWithDescription = ({ tip, debug }: SpinWithDescriptionProps) => {
  if (debug)
    console.debug('SpinWithDescription: ', debug);

  return <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
    <LoadingOutlined />
    {tip ? <Typography.Text type="secondary">{tip}</Typography.Text> : null}
  </div>
}
export default SpinWithDescription;